export const TYPE = [
  { label: 'Select', value: 'FormItem::Select', dataTestId: 'option-select' },
  { label: 'Multiselect', value: 'FormItem::Multiselect', dataTestId: 'option-multiselect' },
  { label: 'Date', value: 'FormItem::Date', dataTestId: 'option-date' },
  { label: 'Number', value: 'FormItem::Number', dataTestId: 'option-number' },
  { label: 'Short Text', value: 'FormItem::Line', dataTestId: 'option-short-text' },
  { label: 'Text', value: 'FormItem::Text', dataTestId: 'option-text' },
  { label: 'Heading', value: 'FormItem::Heading', dataTestId: 'option-heading' },
];

export const defaultLabels = (selectedType) => {
  if (!selectedType || !selectedType.value) return '';

  const labels = {
    'FormItem::Select': 'Who is responsible for the following up?',
    'FormItem::Multiselect': 'Health Outreach Performed',
    'FormItem::Text': 'Vaccination Notes',
    'FormItem::Date': 'When to follow up',
    'FormItem::Heading': 'Additional Details',
    'FormItem::Line': 'Weather',
    'FormItem::Number': 'Hours spent on site',
  };

  return labels[selectedType.value] || '';
};

export const CONTROL_TEXTS = {
  active: {
    title: 'Active',
    description:
        'When checked, this field will be visible and editable in the system. If unchecked, the field will be hidden and cannot be modified.',
  },
  encrypt: {
    title: 'Encrypt',
    description:
        'When checked, the data entered into this field will be encrypted to ensure privacy and security. If unchecked, the data will be stored in plain text. Note: encrypted fields may not be available in offline mode.',
  },
  required: {
    title: 'Required',
    description:
        'When checked, users will be required to enter a value for this field before they can save their data. If unchecked, the field will be optional.',
  },
};

export const parseFieldOptions = (fieldData, selectedType) => {
  if (fieldData?.options) {
    return Array.isArray(fieldData.options)
      ? fieldData.options
      : fieldData.options.split(',') || [];
  }

  const defaultOptions = {
    'FormItem::Select': ['', ''],
    'FormItem::Multiselect': ['', '', ''],
  };

  return defaultOptions[selectedType?.value] || [];
};

export const VALID_TYPES = [
  'FormItem::Select', 'Select',
  'FormItem::Multiselect', 'Multi-select',
  'FormItem::Text', 'Text',
  'FormItem::Date', 'Date',
  'FormItem::Line', 'Short Text',
  'FormItem::Number', 'Number',
];

export const DELETE_WARNING_TEXT = (fieldCount, activeTabName, label) => {
  if (fieldCount === 0) {
    return `This custom field will be removed for all ${activeTabName}s and everyone in your organization. Are you sure you want to delete it?`;
  }

  return `${fieldCount} of your ${activeTabName}s contain data for "${label.toUpperCase()}". This field will be removed for all ${activeTabName}s and everyone in your organization.  Any data currently associated with the field will be permanently deleted. Are you sure you want to remove this custom field?`;
};

export const itemTypes = {
  'FormItem::Multiselect': 'checkbox-group',
  'FormItem::Number': 'number',
  'FormItem::Heading': 'header',
  'FormItem::Select': 'select',
  'FormItem::Line': 'text',
  'FormItem::Text': 'textarea',
  'FormItem::Date': 'date',
};
